import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DropDownLink from './dropDownLink/dropDownLink';

const SideBar = ({
  activeComponent,
  departmentId,
  teamId,
  role,
  siteInfoFeature,
  attCheckIn,
  attCheckInSite,
  getDashboardCount,
  userId,
  isApprovalAllowed,
  attendanceTabFlag,
  darwinManagerCheck,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const dashboardTracker = async () => {
    console.log('clicked');
    await getDashboardCount();
  } 

  return (
    <aside className="main-sidebar scrollbar-styling">
      <section className="sidebar">
        <ul className="sidebar-menu tree">
        
          <li>
            {/* <Link to={`${baseUrl}`}>{localization.dashboard}</Link> */}
          {role.includes(9) ? 
            null 
            :
            <Link onClick={() => dashboardTracker()} to={`${baseUrl}/pm-dashboard`}>{localization.dashboard}</Link>
          }
          </li>
          
          <DropDownLink
            activeComponent={activeComponent}
            departmentId={departmentId}
            teamId={teamId}
            role={role}
            attCheckIn={attCheckIn}
            attCheckInSite={attCheckInSite}
            siteInfoFeature={siteInfoFeature}
            userId={userId}
            isApprovalAllowed={isApprovalAllowed}
            attendanceTabFlag={attendanceTabFlag}
            darwinManagerCheck={darwinManagerCheck}
          />
        </ul>
      </section>
    </aside>
  );
};

export default SideBar;
